(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/animations/joker.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/animations/joker.js');


'use strict';

function getRowWrapperAnimations(_ref) {
  let el = _ref.el,
    callbackScope = _ref.callbackScope,
    onShow = _ref.onShow,
    onHide = _ref.onHide;
  const tl = gsap.timeline({
    callbackScope,
    onComplete: onShow,
    onReverseComplete: onHide,
    paused: true
  });
  tl.fromTo(el, {
    display: 'none'
  }, {
    display: 'block'
  }, '>');
  tl.fromTo(el, 0.4, {
    height: 0
  }, {
    height: 'auto'
  }, '<');
  tl.fromTo(el, 0.1, {
    scale: 0.9,
    opacity: 0
  }, {
    scale: 1,
    opacity: 1
  }, 0.2);
  return {
    show: () => tl.play(0),
    hide: () => tl.reverse(0)
  };
}

function getToggleRowWrapperAnimations(_ref2) {
  let rowEl = _ref2.rowEl,
    textEl = _ref2.textEl;
  const tl = gsap.timeline({
    paused: true
  });
  tl.add(getRowWrapperAnimations({
    el: textEl
  }).hide());
  tl.add(getRowWrapperAnimations({
    el: rowEl
  }).show());
  return {
    showRow: () => tl.play(0),
    showText: () => tl.reverse(0)
  };
}

function getRowAnimations(_ref3) {
  let wrapperEl = _ref3.wrapperEl,
    rowEl = _ref3.rowEl,
    huxfluxBtnEl = _ref3.huxfluxBtnEl,
    callbackScope = _ref3.callbackScope,
    onShow = _ref3.onShow,
    onHide = _ref3.onHide;
  const tl = gsap.timeline({
    callbackScope,
    onComplete: onShow,
    onReverseComplete: onHide,
    paused: true,
    defaults: {
      duration: 0.5
    }
  });
  tl.to(wrapperEl, {
    overflow: 'hidden',
    duration: 0,
    delay: 0
  });
  tl.from(huxfluxBtnEl, {
    opacity: 0,
    x: '100%'
  });
  tl.from(rowEl, {
    opacity: 0,
    x: '20%',
    scale: 0.4
  }, 0);
  tl.to(wrapperEl, {
    overflow: 'visible',
    duration: 0,
    delay: 0
  });
  return {
    show: () => tl.play(0),
    hide: () => tl.reverse(0)
  };
}

function getInputAnimations(_ref4) {
  let el = _ref4.el,
    callbackScope = _ref4.callbackScope,
    onShow = _ref4.onShow,
    onHide = _ref4.onHide;
  const tl = gsap.timeline({
    callbackScope,
    onComplete: onShow,
    onReverseComplete: onHide,
    paused: true,
    defaults: {
      duration: 0.5
    }
  });
  tl.from(el, {
    opacity: 0
  });
  return {
    show: () => tl.play(0),
    hide: () => tl.reverse(0)
  };
}
svs.numbergames.game.animations.joker = {
  getRowWrapperAnimations,
  getRowAnimations,
  getInputAnimations,
  getToggleRowWrapperAnimations
};

 })(window);